/*import React from "react";
import { useForm } from "react-hook-form";
import { withRouter } from "react-router-dom";
import { useStateMachine } from "little-state-machine";
import updateAction from "../updateAction";
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Motivo from '../Motivo'


const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const steps = ['Motivo', 'Passo 2', 'Passo 3'];

function getStepContent(step) {
  switch (step) {
    case 0:
      return <Motivo />;
    case 1:
      return <Typography>PaymentForm</Typography>;
    case 2:
      return <Typography>Review</Typography>;
    default:
      throw new Error('Unknown step');
  }
}


const Contratacao = (props) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);

  let formRef = React.createRef();

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <main className={classes.layout}>
      <Paper className={classes.paper}>
        <Typography component="h1" variant="h4" align="center">
          Movimentação de pessoal
          </Typography>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <React.Fragment>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography variant="h5" gutterBottom>
                Thank you for your order.
                </Typography>
              <Typography variant="subtitle1">
                Your order number is #2001539. We have emailed your order confirmation, and will
                send you an update when your order has shipped.
                </Typography>
            </React.Fragment>
          ) : (

              // <form className={classes.form} onSubmit={e => { e.preventDefault(); handleNext(); console.log(e) }}>
              //   <Button disabled={activeStep === 0} className={classes.button} onClick={handleBack}>
              //     Back
              //   </Button>
              //   <Button variant="contained" color="primary" className={classes.button} type="submit">
              //     {activeStep === 2 ? 'Pay' : 'Next'}
              //   </Button>
              // </form>

              <React.Fragment>
                {getStepContent(activeStep)}
                <div className={classes.buttons}>
                  {activeStep !== 0 && (
                    <Button onClick={handleBack} className={classes.button}>
                      VOLTAR
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? 'FINALIZAR' : 'PROXIMO'}
                  </Button>
                </div>
              </React.Fragment>
            )}
        </React.Fragment>
      </Paper>
    </main>
  );
};

export default Contratacao; */



import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import api from '../../../services/api';
import {
    Grid,
    Button,
    TextField,
    Typography,
    Radio,
    //Select ,
    TextareaAutosize,
} from '@material-ui/core';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from "react-select";

import { useForm, Controller } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import updateAction from "../updateAction";


const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(4)
    },
    title: {
        fontFamily: 'Roboto',
        fontSize: 18,
    },
}));

const empresa = [
    { value: 'mexbrasil', label: 'Mastervig' },
    { value: 'alphalatina', label: 'Alpha Latina' },
    { value: 'techmex', label: 'Tech Mex' },
]
const escolaridade = [
    { value: 'escola1', label: 'Ensino fundamental' },
    { value: 'escola2', label: 'Ensino médio' },
    { value: 'escola3', label: 'Ensino superior' },
];

const escala = [
    { value: 'escala1', label: '5 x 2' },
    { value: 'escala2', label: '6 x 1' },
    { value: 'escala3', label: '12 x 36' },
];

const faixaEtaria = [
    { value: 'faixa1', label: '18-24' },
    { value: 'faixa2', label: '25-30' },
    { value: 'faixa3', label: '31-36' },
    { value: 'faixa4', label: '37-45' },
    { value: 'faixa5', label: 'Acima de 45' },
];

const motivo = [
    { value: 'motivo1', label: 'Aumento de quadro' },
    { value: 'motivo2', label: 'Temporário' },
    { value: 'motivo3', label: 'Implantação' },
    { value: 'motivo4', label: 'Cobertura de férias' },
    { value: 'motivo5', label: 'Cobertura de Licença' },
    { value: 'motivo6', label: 'Substituição de funcionário' },
];

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: '1px dotted pink',
        color: state.isSelected ? 'red' : 'blue',
        padding: 10,
        fontFamily: 'Roboto'
    }),
    // control: () => ({
    //     // none of react-select's styles are passed to <Control />
    //     width: 200,
    // }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';

        return { ...provided, opacity, transition };
    }
}

const Contratacao = (props) => {
    const classes = useStyles();
    const { register, handleSubmit, control } = useForm();
    const { action, state } = useStateMachine(updateAction);

    const onSubmit = data => {
        //action(data);
        console.log(data);
        //props.history.push("./step2");
    };

    return (<div className={classes.root}>
        <Grid container spacing={2}>
            <Grid item lg={12} xs={12} >
                <form className={classes.form} onSubmit={handleSubmit(onSubmit)} >
                    <Typography variant="h2"> Pedido de Recrutamento e Seleção </Typography>
                    <Typography variant="h3"> Informações sobre o colaborador </Typography>

                    <Grid item xs={12} >
                        <FormLabel className={classes.title}>Escolaridade</FormLabel>
                        <Controller
                            as={Select}
                            name="escolaridade"
                            control={control}
                            options={escolaridade}
                            styles={customStyles}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel className={classes.title}>Sexo</FormLabel>
                        <Controller
                            as={
                                <RadioGroup aria-label="sexo">
                                    <FormControlLabel
                                        value="masculino"
                                        control={<Radio />}
                                        label="Masculino"
                                    />
                                    <FormControlLabel
                                        value="feminino"
                                        control={<Radio />}
                                        label="Feminino"
                                    />
                                </RadioGroup>
                            }
                            name="sexo"
                            control={control}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel className={classes.title}>Fumante</FormLabel>
                        <Controller
                            as={
                                <RadioGroup aria-label="Fumante">
                                    <FormControlLabel
                                        value="sim"
                                        control={<Radio />}
                                        label="Sim"
                                    />
                                    <FormControlLabel
                                        value="nao"
                                        control={<Radio />}
                                        label="Não"
                                    />
                                </RadioGroup>
                            }
                            name="Fumante"
                            control={control}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel className={classes.title}>Faixa Etária</FormLabel>
                        <Controller
                            as={Select}
                            name="faixaEtaria"
                            control={control}
                            options={faixaEtaria}
                        />
                    </Grid>
                    <Grid item xs={12}>

                        <FormLabel className={classes.title}>Indicação do Cliente</FormLabel>
                        <Controller
                            as={
                                <RadioGroup aria-label="indicacao">
                                    <FormControlLabel
                                        value="sim"
                                        control={<Radio />}
                                        label="Sim"
                                    />
                                    <FormControlLabel
                                        value="nao"
                                        control={<Radio />}
                                        label="Não"
                                    />
                                </RadioGroup>
                            }
                            name="indicacao"
                            control={control}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormLabel component="legend">Particularidades do Contrato</FormLabel>
                        <TextareaAutosize
                            rowsMin={4}
                            aria-label="maximum height"
                            placeholder=""
                            defaultValue=""
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormLabel component="legend">Habilidades / Conhecimentos</FormLabel>
                        <TextareaAutosize
                            rowsMin={4}
                            aria-label="maximum height"
                            placeholder=""
                            defaultValue=""
                        />
                    </Grid>
                    <Typography variant="h4" gutterBottom>Dados para Admissão</Typography>

                    <Grid item xs={12}>
                        <Controller
                            as={TextField}
                            name="Projeto" control={control} label="Projeto" variant="outlined" />
                    </Grid>
                    <Grid item xs={12}>
                        <Controller
                            as={TextField}
                            name="Cargo" control={control} label="Cargo" variant="outlined" />
                    </Grid>
                    <Grid item xs={12}>
                        <Controller
                            as={TextField}
                            name="Salario" control={control} label="Salario" variant="outlined" />
                    </Grid>
                    <Grid item xs={12}>
                        <Controller
                            as={TextField}
                            name="VT" control={control} label="VT" variant="outlined" />
                    </Grid>
                    <Grid item xs={12}>
                        <Controller
                            as={TextField}
                            name="Horário" control={control} label="Horário (Inclusive sábado)" variant="outlined" />
                    </Grid>
                    <FormLabel className={classes.title}>Empresa</FormLabel>
                    <Controller
                        as={Select}
                        name="reactSelect"
                        control={control}
                        options={empresa}
                    />

                    <FormLabel className={classes.title}>Escala</FormLabel>
                    <Controller
                        as={Select}
                        name="reactSelect"
                        control={control}
                        options={escala}
                    />

                    <Controller
                        as={TextField}
                        name="Insalubridade" control={control} label="Insalubridade(Percentual)" variant="outlined" />

                    <FormLabel className={classes.title}>Plano de Saúde</FormLabel>
                    <Controller
                        as={
                            <RadioGroup aria-label="plsaude">
                                <FormControlLabel
                                    value="sim"
                                    control={<Radio />}
                                    label="Sim"
                                />
                                <FormControlLabel
                                    value="nao"
                                    control={<Radio />}
                                    label="Não"
                                />
                            </RadioGroup>
                        }
                        name="plsaude"
                        control={control}
                    />

                    <FormLabel className={classes.title}>Plano de saúde extensivo a dependentes</FormLabel>
                    <Controller
                        as={
                            <RadioGroup aria-label="plsaudedep">
                                <FormControlLabel
                                    value="sim"
                                    control={<Radio />}
                                    label="Sim"
                                />
                                <FormControlLabel
                                    value="nao"
                                    control={<Radio />}
                                    label="Não"
                                />
                            </RadioGroup>
                        }
                        name="plsaudedep"
                        control={control}
                    />

                    <FormLabel className={classes.title}>Adicional Noturno</FormLabel>
                    <Controller
                        as={
                            <RadioGroup aria-label="adnot">
                                <FormControlLabel
                                    value="sim"
                                    control={<Radio />}
                                    label="Sim"
                                />
                                <FormControlLabel
                                    value="nao"
                                    control={<Radio />}
                                    label="Não"
                                />
                            </RadioGroup>
                        }
                        name="adnot"
                        control={control}
                    />

                    <FormLabel className={classes.title}>Periculosidade</FormLabel>
                    <Controller
                        as={
                            <RadioGroup aria-label="periculosidade">
                                <FormControlLabel
                                    value="sim"
                                    control={<Radio />}
                                    label="Sim"
                                />
                                <FormControlLabel
                                    value="nao"
                                    control={<Radio />}
                                    label="Não"
                                />
                            </RadioGroup>
                        }
                        name="periculosidade"
                        control={control}
                    />

                    <FormLabel className={classes.title}>Alimentação</FormLabel>
                    <Controller
                        as={
                            <RadioGroup aria-label="alimentacao">
                                <FormControlLabel
                                    value="nolocal"
                                    control={<Radio />}
                                    label="No Local"
                                />
                                <FormControlLabel
                                    value="sindicato"
                                    control={<Radio />}
                                    label="Sindicato"
                                />
                                <FormControlLabel
                                    value="outro"
                                    control={<Radio />}
                                    label="Outro"
                                />
                            </RadioGroup>
                        }
                        name="alimentacao"
                        control={control}
                    />

                    <Controller
                        as={TextField}
                        name="PATDif" control={control} label="Informe o valor do PAT diferenciado" variant="outlined" />

                    <FormLabel className={classes.title}>Cesta básica</FormLabel>
                    <Controller
                        as={
                            <RadioGroup aria-label="cestabasica">
                                <FormControlLabel
                                    value="nolocal"
                                    control={<Radio />}
                                    label="No Local"
                                />
                                <FormControlLabel
                                    value="sindicato"
                                    control={<Radio />}
                                    label="Sindicato"
                                />
                                <FormControlLabel
                                    value="outro"
                                    control={<Radio />}
                                    label="Outro"
                                />
                            </RadioGroup>
                        }
                        name="cestabasica"
                        control={control}
                    />

                    <Typography className={classes.title} variant="h4">
                        Movimentação de Pessoal
                            </Typography>

                    <Button
                        className={classes.signInButton}
                        color="primary"
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                    >
                        SELECIONAR
                            </Button>
                </form>
            </Grid>
        </Grid >
    </div >
    );
};

export default Contratacao;
/*

<div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item lg={12} xs={12} >
                    <form className={classes.form}
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Typography variant="h2">
                            Pedido de Recrutamento e Seleção
                                </Typography>


                        <Typography variant="h3">
                            Informações sobre o colaborador
                                </Typography>


                        <Grid item xs={12}>
                            <FormLabel className={classes.title}>Escolaridade</FormLabel>
                            <Controller
                                as={Select}
                                name="escolaridade"
                                control={control}
                                options={escolaridade}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormLabel className={classes.title}>Sexo</FormLabel>
                            <Controller
                                as={
                                    <RadioGroup aria-label="sexo">
                                        <FormControlLabel
                                            value="masculino"
                                            control={<Radio />}
                                            label="Masculino"
                                        />
                                        <FormControlLabel
                                            value="feminino"
                                            control={<Radio />}
                                            label="Feminino"
                                        />
                                    </RadioGroup>
                                }
                                name="sexo"
                                control={control}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormLabel className={classes.title}>Fumante</FormLabel>
                            <Controller
                                as={
                                    <RadioGroup aria-label="Fumante">
                                        <FormControlLabel
                                            value="sim"
                                            control={<Radio />}
                                            label="Sim"
                                        />
                                        <FormControlLabel
                                            value="nao"
                                            control={<Radio />}
                                            label="Não"
                                        />
                                    </RadioGroup>
                                }
                                name="Fumante"
                                control={control}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormLabel className={classes.title}>Faixa Etária</FormLabel>
                            <Controller
                                as={Select}
                                name="faixaEtaria"
                                control={control}
                                options={faixaEtaria}
                            />
                        </Grid>
                        <Grid item xs={12}>

                            <FormLabel className={classes.title}>Indicação do Cliente</FormLabel>
                            <Controller
                                as={
                                    <RadioGroup aria-label="indicacao">
                                        <FormControlLabel
                                            value="sim"
                                            control={<Radio />}
                                            label="Sim"
                                        />
                                        <FormControlLabel
                                            value="nao"
                                            control={<Radio />}
                                            label="Não"
                                        />
                                    </RadioGroup>
                                }
                                name="indicacao"
                                control={control}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormLabel component="legend">Particularidades do Contrato</FormLabel>
                            <TextareaAutosize
                                rowsMin={4}
                                aria-label="maximum height"
                                placeholder=""
                                defaultValue=""
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormLabel component="legend">Habilidades / Conhecimentos</FormLabel>
                            <TextareaAutosize
                                rowsMin={4}
                                aria-label="maximum height"
                                placeholder=""
                                defaultValue=""
                            />
                        </Grid>
                        <Typography variant="h4" gutterBottom>Dados para Admissão</Typography>

                        <Grid item xs={12}>
                            <Controller
                                as={TextField}
                                name="Projeto" control={control} label="Projeto" variant="outlined" />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                as={TextField}
                                name="Cargo" control={control} label="Cargo" variant="outlined" />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                as={TextField}
                                name="Salario" control={control} label="Salario" variant="outlined" />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                as={TextField}
                                name="VT" control={control} label="VT" variant="outlined" />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                as={TextField}
                                name="Horário" control={control} label="Horário (Inclusive sábado)" variant="outlined" />
                        </Grid>
                        <FormLabel className={classes.title}>Empresa</FormLabel>
                        <Controller
                            as={Select}
                            name="reactSelect"
                            control={control}
                            options={empresa}
                        />

                        <FormLabel className={classes.title}>Escala</FormLabel>
                        <Controller
                            as={Select}
                            name="reactSelect"
                            control={control}
                            options={escala}
                        />

                        <Controller
                            as={TextField}
                            name="Insalubridade" control={control} label="Insalubridade(Percentual)" variant="outlined" />

                        <FormLabel className={classes.title}>Plano de Saúde</FormLabel>
                        <Controller
                            as={
                                <RadioGroup aria-label="plsaude">
                                    <FormControlLabel
                                        value="sim"
                                        control={<Radio />}
                                        label="Sim"
                                    />
                                    <FormControlLabel
                                        value="nao"
                                        control={<Radio />}
                                        label="Não"
                                    />
                                </RadioGroup>
                            }
                            name="plsaude"
                            control={control}
                        />

                        <FormLabel className={classes.title}>Plano de saúde extensivo a dependentes</FormLabel>
                        <Controller
                            as={
                                <RadioGroup aria-label="plsaudedep">
                                    <FormControlLabel
                                        value="sim"
                                        control={<Radio />}
                                        label="Sim"
                                    />
                                    <FormControlLabel
                                        value="nao"
                                        control={<Radio />}
                                        label="Não"
                                    />
                                </RadioGroup>
                            }
                            name="plsaudedep"
                            control={control}
                        />

                        <FormLabel className={classes.title}>Adicional Noturno</FormLabel>
                        <Controller
                            as={
                                <RadioGroup aria-label="adnot">
                                    <FormControlLabel
                                        value="sim"
                                        control={<Radio />}
                                        label="Sim"
                                    />
                                    <FormControlLabel
                                        value="nao"
                                        control={<Radio />}
                                        label="Não"
                                    />
                                </RadioGroup>
                            }
                            name="adnot"
                            control={control}
                        />

                        <FormLabel className={classes.title}>Periculosidade</FormLabel>
                        <Controller
                            as={
                                <RadioGroup aria-label="periculosidade">
                                    <FormControlLabel
                                        value="sim"
                                        control={<Radio />}
                                        label="Sim"
                                    />
                                    <FormControlLabel
                                        value="nao"
                                        control={<Radio />}
                                        label="Não"
                                    />
                                </RadioGroup>
                            }
                            name="periculosidade"
                            control={control}
                        />

                        <FormLabel className={classes.title}>Alimentação</FormLabel>
                        <Controller
                            as={
                                <RadioGroup aria-label="alimentacao">
                                    <FormControlLabel
                                        value="nolocal"
                                        control={<Radio />}
                                        label="No Local"
                                    />
                                    <FormControlLabel
                                        value="sindicato"
                                        control={<Radio />}
                                        label="Sindicato"
                                    />
                                    <FormControlLabel
                                        value="outro"
                                        control={<Radio />}
                                        label="Outro"
                                    />
                                </RadioGroup>
                            }
                            name="alimentacao"
                            control={control}
                        />

                        <Controller
                            as={TextField}
                            name="PATDif" control={control} label="Informe o valor do PAT diferenciado" variant="outlined" />

                        <FormLabel className={classes.title}>Cesta básica</FormLabel>
                        <Controller
                            as={
                                <RadioGroup aria-label="cestabasica">
                                    <FormControlLabel
                                        value="nolocal"
                                        control={<Radio />}
                                        label="No Local"
                                    />
                                    <FormControlLabel
                                        value="sindicato"
                                        control={<Radio />}
                                        label="Sindicato"
                                    />
                                    <FormControlLabel
                                        value="outro"
                                        control={<Radio />}
                                        label="Outro"
                                    />
                                </RadioGroup>
                            }
                            name="cestabasica"
                            control={control}
                        />

                        <Typography className={classes.title} variant="h4">
                            Movimentação de Pessoal
                                </Typography>













                        <Button
                            className={classes.signInButton}
                            color="primary"
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                        >
                            SELECIONAR
                                </Button>

                    </form>
                </Grid>
            </Grid >
        </div >
        */